export const GLOBAL_VARIABLES ={
    NO_SERVER_CONNECTION: 'ארעה שגיאה, נסו שוב מאוחר יותר',
    NO_ACCOUNT_FOUND: 'שם המשתמש והסיסמא לא תואמים, נסו שוב',
}